import type { TranslationResources } from "@project/lib/locales/en";
import careGu from "@project/lib/locales/sections/care.gu";
import programsGu from "@project/lib/locales/sections/programs.gu";
import trustGu from "@project/lib/locales/sections/trust.gu";
import communityGu from "@project/lib/locales/sections/community.gu";
import pagesGu from "@project/lib/locales/sections/pages.gu";
import accountGu from "@project/lib/locales/sections/account.gu";

export const gu: TranslationResources = {
  common: {
    siteName: "જીવનધારા વૃદ્ધાશ્રમ",
    tagline: "દરેક વડીલ માટે ગૌરવ, સંભાળ અને કરુણા",
    careCompassionCommunity: "સંભાળ • કરુણા • સમુદાય",
    verified: "પ્રમાણિત",
    certified: "12A • 80G પ્રમાણિત",
    browseCauses: "કારણો જુઓ",
    register: "નોંધણી કરો",
    learnMore: "વધુ જાણો",
  },
  brand: {
    title: "જીવનધારા",
    subtitle: "વૃદ્ધાશ્રમ",
  },
  nav: {
    home: "મુખ્ય",
    about: "અમારા વિશે",
    donation: "દાન",
    bhojanshala: "ભોજનશાળા",
    events: "પ્રસંગો",
    gaushala: "ગૌશાળા",
    contact: "સંપર્ક",
    more: "વધુ",
  },
  menu: {
    applyAdmission: "પ્રવેશ માટે અરજી કરો",
    residentCare: "નિવાસી સંભાળ",
    elderCareProgram: "વડીલ સંભાળ કાર્યક્રમ",
    healthcare: "આરોગ્ય સંભાળ",
    gaushala: "ગૌશાળા",
    events: "પ્રસંગો",
    gruhUdhyog: "ગૃહ ઉદ્યોગ",
    transparency: "પારદર્શિતા અને અસર",
    tiffinSeva: "ટિફિન સેવા",
    news: "સમાચાર",
    committee: "સમિતિ",
    trustees: "ટ્રસ્ટીઓ",
    gallery: "ગેલેરી",
    visitorForm: "મુલાકાત ફોર્મ",
    feedback: "પ્રતિભાવ",
    jainPanchang: "જૈન પંચાંગ",
  },
  lang: {
    english: "English",
    gujarati: "ગુજરાતી",
    change: "ભાષા બદલો",
  },
  footer: {
    quickLinks: "ઝડપી લિંક્સ",
    services: "સેવાઓ",
    reachUs: "અમારો સંપર્ક",
    rights: "સર્વ હક અમારા સ્વાધીન.",
    aboutUs: "અમારા વિશે",
    residentCare: "નિવાસી સંભાળ",
    donateLink: "દાન",
    events: "દાન પ્રસંગો",
    contact: "સંપર્ક",
    gaushala: "ગૌશાળા",
    bhojanTithi: "ભોજનશાળા",
    tiffinSeva: "ટિફિન સેવા",
    gruhUdhyog: "ગૃહ ઉદ્યોગ",
    address: "જીવનધારા વૃદ્ધાશ્રમ, લાંભા",
    phone: "+91 00000 00000",
    email: "jivandharavrudhashram@gmail.com",
  },
  home: {
    hero: {
      greeting: "Pranam · प्रणाम · પ્રણામ",
      titleLine1: "દરેક આશ્રમવાસી વડીલ માટે",
      titleLine2: "એક પ્રેમાળ ઘર, રોજેરોજ",
      sanskrit: "मातृ देवो भव · पितृ देवो भव",
      description:
        "આશ્રય, ભોજન, તબીબી સંભાળ અને ગૌરવ પૂરું પાડતું એક સંપૂર્ણ સેવા પ્લેટફોર્મ — જૈન સમુદાય અને તેનાથી આગળના વડીલો માટે કરુણાથી ઘડાયેલું.",
      feature1: "આજીવન નિવાસી સંભાળ",
      feature2: "12A અને 80G કર લાભ",
      feature3: "1000+ દાતાઓનો વિશ્વાસ",
      admissionApplication: "પ્રવેશ અરજી",
      admissionInquiry: "પ્રવેશ પૂછપરછ",
    },
    statsCard: {
      residents: "નિવાસીઓ",
      caredFor: "ની સંભાળ",
      yearsOf: "વર્ષોની",
      seva: "સેવા",
      generous: "ઉદાર",
      donors: "દાતાઓ",
      dailyCare: "દૈનિક સંભાળ",
      medical: "તબીબી",
      shelter: "આશ્રય",
      thisMonth: "આ મહિને",
    },
    trust: {
      heading: "ગુજરાત અને ભારતભરના પરિવારો અને સમુદાયોનો વિશ્વાસ",
      residentsCared: "સંભાળ પામેલા નિવાસીઓ",
      generousDonors: "ઉદાર દાતાઓ",
      donationsProcessed: "પ્રક્રિયા થયેલાં દાન",
      ofTrustedSeva: "વિશ્વસનીય સેવાનાં",
    },
    admission: {
      badge: "પ્રવેશ પૂછપરછ",
      heading: "શું તમે કોઈ વડીલને અમારા ઘરમાં દાખલ કરવા માંગો છો?",
      description:
        "એક સરળ પ્રવેશ અરજી સબમિટ કરો — અરજદાર, વડીલ અને પરિવારની વિગતો શેર કરો. અમારી ટીમ 3 કાર્યકારી દિવસોમાં તમારો સંપર્ક કરીને આગળનાં પગલાં માટે માર્ગદર્શન આપશે.",
      feature1: "નિ:શુલ્ક પ્રવેશ પૂછપરછ",
      feature2: "ગોપનીય પરિવાર માહિતી",
      feature3: "વ્યક્તિગત ફોલો-અપ કૉલ",
      feature4: "આશ્રમ મુલાકાત અને ઇન્ટરવ્યુ",
      applyButton: "પ્રવેશ પૂછપરછ શરૂ કરો",
      talkButton: "અમારી ટીમ સાથે વાત કરો",
      eldersAdmitted: "દાખલ થયેલા વડીલો",
      howItWorks: "આ કેવી રીતે કાર્ય કરે છે",
      step1: "1. પ્રવેશ પૂછપરછ સબમિટ કરો",
      step2: "2. અમારી ટીમ દ્વારા પ્રારંભિક ટેલિફોનિક સમીક્ષા",
      step3: "3. પરિવાર બેઠક અને ઘર મુલાકાત",
      step4: "4. પ્રવેશ પુષ્ટિ",
    },
    visitors: {
      badge: "મુલાકાત કનેક્ટ",
      heading: "મુલાકાતની યોજના કરી રહ્યા છો કે તમારો અનુભવ શેર કરી રહ્યા છો?",
      description:
        "તમારી જરૂરિયાતને અનુરૂપ વિકલ્પ પસંદ કરો. આગામી મુલાકાત માટે વિઝિટર ઇન્ક્વાયરી ફોર્મ ભરો અથવા વિઝિટર ફીડબેક ફોર્મ દ્વારા તમારો અનુભવ, પ્રશંસા અને સૂચનો શેર કરો.",
      feature1: "આગામી મુલાકાતની નોંધણી કરો",
      feature2: "તમારી મુલાકાતનો પ્રતિભાવ શેર કરો",
      feature3: "પરિવારની મુલાકાત વિગતો સમર્થિત",
      feature4: "દરેક મુલાકાત સુધારવામાં મદદ કરો",
      applyButton: "મુલાકાત ફોર્મ્સ",
      talkButton: "અમારી ટીમ સાથે વાત કરો",
      visitsLogged: "મુલાકાતી ક્રિયાપ્રતિક્રિયાઓ",
      howItWorks: "આ કેવી રીતે કાર્ય કરે છે",
      step1: "1. યોગ્ય મુલાકાત ફોર્મ પસંદ કરો.",
      step2: "2. જરૂરી વિગતો પૂર્ણ કરો.",
      step3: "3. તમારી પૂછપરછ અથવા પ્રતિભાવ સબમિટ કરો.",
      step4: "4. અમારી ટીમ સમીક્ષા કરશે અને જરૂર પડે તો જવાબ આપશે.",
    },
    visitorChooser: {
      badge: "મુલાકાત ફોર્મ્સ",
      title: "તમે કેવી રીતે જોડાવા માંગો છો?",
      description:
        "પસંદ કરો કે તમે અગાઉની મુલાકાતનો પ્રતિભાવ આપવા માંગો છો, કે આગામી મુલાકાતની નોંધણી કરવા માંગો છો.",
      feedbackTitle: "મુલાકાતી પ્રતિભાવ ફોર્મ",
      feedbackDescription:
        "જીવનધારાની મુલાકાત બાદ તમારો અનુભવ, સૂચનો અથવા પ્રશંસા શેર કરો.",
      feedbackCta: "પ્રતિભાવ ફોર્મ ખોલો",
      inquiryTitle: "મુલાકાત પૂછપરછ ફોર્મ",
      inquiryDescription:
        "મુલાકાતની યોજના છે? મુલાકાત વિગતો, કારણ અને સંદર્ભ માહિતી શેર કરો.",
      inquiryCta: "પૂછપરછ ફોર્મ ખોલો",
    },
    schemes: {
      eyebrow: "Jivandhara શોધો",
      heading: "અમારી સેવાઓ જાણો",
      description:
        "કરુણામય સંભાળ, આરોગ્યસેવા, સેવા અને સાંસ્કૃતિક મૂલ્યોના સંરક્ષણ દ્વારા Jivandhara વડીલો અને સમુદાયની કેવી રીતે સેવા કરે છે તે જાણો.",
      residentCareTitle: "નિવાસી સંભાળ",
      residentCareDesc:
        "જાણો કે અમે કેવી રીતે સુરક્ષિત, સંભાળભર્યું અને ગૌરવપૂર્ણ ઘર પૂરું પાડીએ છીએ, જ્યાં દરેક વડીલને પ્રેમ, આદર અને કરુણા સાથે વર્તવામાં આવે છે.",
      residentCareButton: "સંભાળ જુઓ",
      gaushalaTitle: "વૃંદાવન ગીર ગૌશાળા",
      gaushalaDesc:
        "અમારી ગૌશાળા શોધો, જે સ્થાનિક ગીર ગાયોની સંભાળ અને અમારી સમૃદ્ધ સાંસ્કૃતિક અને આધ્યાત્મિક વિરાસતના સંરક્ષણ માટે સમર્પિત છે.",
      gaushalaButton: "ગૌશાળા જુઓ",
      tiffinTitle: "ટિફિન સેવા",
      tiffinDesc:
        "જરૂરિયાતમંદ નિવાસીઓને ગરમ, ઘરે બનાવેલા ટિફિન પૂરા પાડો.",
      tiffinButton: "નોંધણી કરો",
      healthcareTitle: "આરોગ્યસેવા",
      healthcareDesc:
        "અમારી તબીબી સuvિધાઓ, નિયમિત આરોગ્ય તપાસ, ફિઝિયોથેરાપી અને દરેક નિવાસી માટે કરુણામય આરોગ્યસેવા વિશે જાણો.",
      healthcareButton: "આરોગ્યસેવા જુઓ",
    },
    glimpses: {
      eyebrow: "સેવાની ઝલક",
      heading: "અમારા ઘરની ક્ષણો",
      description:
        "સંભાળ, સાથ અને ગૌરવ — માનવસેવામાં રોજેરોજ ઝિલાયેલું.",
      festivalLabel: "ઉત્સવ અને ઉજવણીઓ",
      festivalSub: "Jivandhara ખાતે પવિત્ર ઉત્સવ અને આનંદમય ઉજવણીઓ",
      gaushalaLabel: "ગૌશાળા",
      gaushalaSub: "અમારી વૃંદાવન ગીર ગૌશાળામાં ગાયોની સંભાળ",
      derasarLabel: "દેરાસર",
      derasarSub: "અમારા મંદિરમાં દૈનિક પૂજા અને આધ્યાત્મિક શાંતિ",
      viewGallery: "સંપૂર્ણ ગેલેરી જુઓ",
    },
    testimonials: {
      eyebrow: "વિશ્વાસના સ્વર",
      heading: "અમારા સમર્થકો શું કહે છે",
      description:
        "દાતાઓ, પરિવારો અને સેવા પ્રતિ વિશ્વાસ રાખનાર સુખદાયક શબ્દો.",
    },
    pillars: {
      residentCareTitle: "નિવાસી સંભાળ",
      residentCareBody:
        "દરેક નિવાસી માટે આજીવન આશ્રય, ભોજન, દૈનિક સંભાળ અને સાથ.",
      medicalTitle: "તબીબી સહાય",
      medicalBody:
        "ઑન-કૉલ ડૉક્ટરો, દૈનિક દવાઓ, હૉસ્પિટલ જોડાણ અને કટોકટી સંભાળ.",
      ritualsTitle: "વિધિ અને ગૌરવ",
      ritualsBody:
        "જન્મદિવસથી લઈને અંતિમ સંસ્કાર સુધી — દરેક પ્રસંગ આદર સાથે ઊજવાય છે.",
    },
    shloka: {
      sanskrit: "“यत्र वृद्धाः पूज्यन्ते तत्र देवताः रमन्ते।”",
      translation: "જ્યાં વૃદ્ધોનું સન્માન થાય, ત્યાં દેવતા વસે છે.",
    },
    cta: {
      headingBefore: "અમારા",
      headingHighlight: "પરિવાર",
      headingAfter: "નો ભાગ બનો",
      description:
        "અતિથિ દેવો ભવ · अतिथि देवो भव — મુલાકાત લો, સ્વયંસેવા કરો, દાન કરો અથવા ફક્ત શેર કરો. દયાનું દરેક કાર્ય અનેકગણું વધે છે.",
      donateNow: "હમણાં દાન કરો",
      visitUs: "અમારી મુલાકાત લો",
    },
  },
  care: careGu,
  programs: programsGu,
  trust: trustGu,
  community: communityGu,
  pages: pagesGu,
  account: accountGu,
};
